/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GAME_IMAGE_ORIENTATION {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
